import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { msg } from '@lingui/core/macro';
import { productField, productQuantityField } from './common/productFields';
import { genericUnitField } from './common/sharedFields';

export const consumerGoodsProductAssessmentMetadata = {
  displayName: msg({
    message: 'Product assessment',
    context: 'Activity data schema name for product assessment',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    product: productField,
    quantity: productQuantityField,
    unit: genericUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
